import { MILLION } from '@/consts';

function getPrincipal(approvedAmount, interestRate, prepaid) {
  if (prepaid) {
    return ((approvedAmount * MILLION) - ((approvedAmount * MILLION * interestRate) / 100)) / MILLION;
  }
  return parseFloat(approvedAmount / MILLION);
}

export function getRoundPrincipal(approvedAmount, interestRate, prepaid) {
  const principal = getPrincipal(approvedAmount, interestRate, prepaid);
  return Math.floor(principal * 1000) / 1000;
}

export function getRoundFee(approvedAmount, interestRate, prepaid) {
  if (prepaid) {
    const principal = getPrincipal(approvedAmount, interestRate, prepaid);

    const upperPrincipal = Math.round(principal * 1000);

    const downPrincipal = Math.floor(principal * 1000);

    if (upperPrincipal - downPrincipal === 1) {
      return 0.001;
    }
  }
  return 0;
}

export function getInterestValue(approvedAmount, interestRate, prepaid) {
  if (prepaid) {
    const roundPrincipal = getRoundPrincipal(approvedAmount, interestRate, prepaid);

    return Math.round((approvedAmount * MILLION - roundPrincipal * MILLION) / 1000) / 1000;
  }
  return Math.round(((approvedAmount * 1000) * interestRate) / 100) / 1000;
}

export function getInterestDiscountAmount(approvedAmount, interestValue, interestDiscount, maxDiscount, minDiscount, minPayout) {
  try {
    if (minPayout <= approvedAmount) {
      const interestDiscountAmount = Math.round(((interestValue * interestDiscount) / 100) * 1000) / 1000;

      if (interestDiscountAmount < minDiscount) {
        return minDiscount;
      }

      if (interestDiscountAmount > maxDiscount) {
        return maxDiscount;
      }

      if (interestDiscountAmount > interestValue) {
        return interestValue;
      }

      return interestDiscountAmount;
    }
  } catch (error) {
    return 0;
  }
  return 0;
}
